import { render, staticRenderFns } from "./PopUpDatatable.vue?vue&type=template&id=487c0099"
import script from "./PopUpDatatable.vue?vue&type=script&lang=js"
export * from "./PopUpDatatable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports